/**
 * @generated SignedSource<<4284630581d7b3611248bfde8a8ca35f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotesOrder = "mostRecent" | "mostVotes" | "%future added value";
export type ProposalsPageDetailQuery$variables = {
  address: string;
  orderBy: VotesOrder;
  proposalId: string;
  skipAddress: boolean;
};
export type ProposalsPageDetailQuery$data = {
  readonly firstProposal: {
    readonly number: string;
    readonly " $fragmentSpreads": FragmentRefs<"FeedbackCastPanelFragment" | "ProposalDetailPanelFragment" | "VotesCastPanelFragment">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProposalActionPanelFragment">;
};
export type ProposalsPageDetailQuery = {
  response: ProposalsPageDetailQuery$data;
  variables: ProposalsPageDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "address"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "proposalId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAddress"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "proposalId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v6 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v7 = {
  "kind": "Variable",
  "name": "proposalId",
  "variableName": "proposalId"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ResolvedName",
  "kind": "LinkedField",
  "name": "resolvedName",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Address",
    "kind": "LinkedField",
    "name": "address",
    "plural": false,
    "selections": (v10/*: any*/),
    "storageKey": null
  },
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "ProposalUpdate",
  "kind": "LinkedField",
  "name": "updateHistory",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v16 = {
  "kind": "Literal",
  "name": "first",
  "value": 30
},
v17 = [
  (v16/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Address",
    "kind": "LinkedField",
    "name": "address",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "storageKey": null
  },
  (v12/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Delegate",
  "kind": "LinkedField",
  "name": "executor",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "VotingPower",
  "kind": "LinkedField",
  "name": "votes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "amount",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Delegate",
  "kind": "LinkedField",
  "name": "voter",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportDetailed",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = [
  (v16/*: any*/),
  (v7/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Delegate",
  "kind": "LinkedField",
  "name": "sender",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "OnChainProposal",
  "kind": "LinkedField",
  "name": "proposal",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approximateTimestamp",
  "storageKey": null
},
v31 = [
  (v7/*: any*/)
],
v32 = [
  (v24/*: any*/),
  (v12/*: any*/)
],
v33 = {
  "alias": null,
  "args": (v31/*: any*/),
  "concreteType": "DelegateSnapshot",
  "kind": "LinkedField",
  "name": "delegateSnapshot",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Noun",
      "kind": "LinkedField",
      "name": "nounsRepresented",
      "plural": true,
      "selections": (v32/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": (v31/*: any*/),
  "concreteType": "Vote",
  "kind": "LinkedField",
  "name": "proposalVote",
  "plural": false,
  "selections": (v32/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProposalsPageDetailQuery",
    "selections": [
      {
        "alias": "firstProposal",
        "args": (v4/*: any*/),
        "concreteType": "OnChainProposal",
        "kind": "LinkedField",
        "name": "onChainProposal",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProposalDetailPanelFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VotesCastPanelFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeedbackCastPanelFragment"
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "address",
            "variableName": "address"
          },
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "skipAddress",
            "variableName": "skipAddress"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ProposalActionPanelFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProposalsPageDetailQuery",
    "selections": [
      {
        "alias": "firstProposal",
        "args": (v4/*: any*/),
        "concreteType": "OnChainProposal",
        "kind": "LinkedField",
        "name": "onChainProposal",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatePeriodEndsAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "objectionPeriodEndsAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "voteEndsAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "voteStartsAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProposalTransaction",
            "kind": "LinkedField",
            "name": "transactions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signature",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calldata",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "proposer",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "signers",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "forVotes",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "againstVotes",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "quorumVotes",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "abstainVotes",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAggregates",
            "kind": "LinkedField",
            "name": "feedbackAggregates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TokenAmount",
                "kind": "LinkedField",
                "name": "positiveFeedback",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TokenAmount",
                "kind": "LinkedField",
                "name": "negativeFeedback",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TokenAmount",
                "kind": "LinkedField",
                "name": "neutralFeedback",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProposalUpdate",
                "kind": "LinkedField",
                "name": "updateHistory",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transactionHash",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdatableProposal",
            "abstractKey": "__isUpdatableProposal"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v17/*: any*/),
        "concreteType": "VotesConnection",
        "kind": "LinkedField",
        "name": "votes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VotesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Vote",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v12/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              (v25/*: any*/)
            ],
            "storageKey": null
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v17/*: any*/),
        "filters": [
          "proposalId",
          "orderBy"
        ],
        "handle": "connection",
        "key": "VotesCastPanelFragment_votes",
        "kind": "LinkedHandle",
        "name": "votes"
      },
      {
        "alias": null,
        "args": (v27/*: any*/),
        "concreteType": "ProposalFeedbackConnection",
        "kind": "LinkedField",
        "name": "proposalFeedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProposalFeedbackEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProposalFeedback",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  (v12/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              (v25/*: any*/)
            ],
            "storageKey": null
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v27/*: any*/),
        "filters": [
          "proposalId"
        ],
        "handle": "connection",
        "key": "FeedbackCastPanelFragment_proposalFeedback",
        "kind": "LinkedHandle",
        "name": "proposalFeedback"
      },
      {
        "condition": "skipAddress",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "addressOrEnsName",
                "variableName": "address"
              }
            ],
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "delegate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DelegateStatement",
                "kind": "LinkedField",
                "name": "statement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statement",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TopIssue",
                    "kind": "LinkedField",
                    "name": "topIssues",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "address",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "canVote",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "currentlyActive",
                        "value": true
                      },
                      {
                        "fields": (v31/*: any*/),
                        "kind": "ObjectValue",
                        "name": "forProposal"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "LiquidDelegationRepresentation",
                "kind": "LinkedField",
                "name": "liquidRepresentation",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Delegate",
                    "kind": "LinkedField",
                    "name": "proxy",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Vote",
                "kind": "LinkedField",
                "name": "votes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OnChainProposal",
                    "kind": "LinkedField",
                    "name": "proposal",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v19/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v31/*: any*/),
                "concreteType": "ProposalFeedback",
                "kind": "LinkedField",
                "name": "proposalFeedback",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v29/*: any*/),
                  (v28/*: any*/),
                  (v30/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "711538d425ac0c6b8dcbf2e329ac30a5",
    "id": null,
    "metadata": {},
    "name": "ProposalsPageDetailQuery",
    "operationKind": "query",
    "text": "query ProposalsPageDetailQuery(\n  $proposalId: ID!\n  $address: String!\n  $skipAddress: Boolean!\n  $orderBy: VotesOrder!\n) {\n  firstProposal: onChainProposal(id: $proposalId) {\n    number\n    ...ProposalDetailPanelFragment\n    ...VotesCastPanelFragment\n    ...FeedbackCastPanelFragment\n    id\n  }\n  ...ProposalActionPanelFragment_zQ1q7\n}\n\nfragment CastVoteInputFragment on OnChainProposal {\n  description\n  status\n}\n\nfragment CastVoteInputQueryFragment_248kg0 on Query {\n  delegate(addressOrEnsName: $address) @skip(if: $skipAddress) {\n    statement {\n      statement\n      topIssues {\n        type\n        value\n      }\n    }\n    id\n  }\n}\n\nfragment CastVoteInputVoteButtonsFragment on OnChainProposal {\n  id\n  status\n}\n\nfragment CastVoteInputVoteButtonsQueryFragment_248kg0 on Query {\n  delegate(addressOrEnsName: $address) @skip(if: $skipAddress) {\n    address {\n      address\n    }\n    delegateSnapshot(proposalId: $proposalId) {\n      nounsRepresented {\n        __typename\n        id\n      }\n    }\n    proposalVote(proposalId: $proposalId) {\n      __typename\n      id\n    }\n    liquidRepresentation(filter: {canVote: true, currentlyActive: true, forProposal: {proposalId: $proposalId}}) {\n      proxy {\n        delegateSnapshot(proposalId: $proposalId) {\n          nounsRepresented {\n            __typename\n            id\n          }\n        }\n        proposalVote(proposalId: $proposalId) {\n          __typename\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment FeedbackCastPanelFeedbackFragment_2bW5VT on Query {\n  proposalFeedback(proposalId: $proposalId, first: 30) {\n    edges {\n      node {\n        sender {\n          address {\n            address\n          }\n          id\n        }\n        ...FeedbackRowFragment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FeedbackCastPanelFragment on OnChainProposal {\n  number\n  ...ProposalFeedbackSummaryFragment\n}\n\nfragment FeedbackCastPanelOwnFeedbackFragment_2wcrcu on Query {\n  delegate(addressOrEnsName: $address) @skip(if: $skipAddress) {\n    proposalFeedback(proposalId: $proposalId) {\n      ...FeedbackRowFragment\n      id\n    }\n    id\n  }\n}\n\nfragment FeedbackCastPanelQueryFragment_2wcrcu on Query {\n  ...FeedbackCastPanelFeedbackFragment_2bW5VT\n  ...FeedbackCastPanelOwnFeedbackFragment_2wcrcu\n  ...GiveFeedbackInputFeedbackButtonsQueryFragment_248kg0\n}\n\nfragment FeedbackRowFragment on ProposalFeedback {\n  id\n  reason\n  votes {\n    amount {\n      amount\n    }\n  }\n  proposal {\n    updateHistory {\n      timestamp\n      id\n    }\n    id\n  }\n  sender {\n    address {\n      address\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    id\n  }\n  approximateTimestamp\n  ...FeedbackRowTextFragment\n}\n\nfragment FeedbackRowTextFragment on ProposalFeedback {\n  supportDetailed\n}\n\nfragment GiveFeedbackInputFeedbackButtonsQueryFragment_248kg0 on Query {\n  delegate(addressOrEnsName: $address) @skip(if: $skipAddress) {\n    address {\n      address\n    }\n    id\n  }\n}\n\nfragment NounResolvedLinkFragment on ResolvedName {\n  address\n  name\n  ...NounResolvedNameFragment\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment ProposalActionPanelFragment_zQ1q7 on Query {\n  ...VotesCastPanelQueryFragment_zQ1q7\n  ...FeedbackCastPanelQueryFragment_2wcrcu\n}\n\nfragment ProposalDetailPanelFragment on OnChainProposal {\n  number\n  title\n  description\n  status\n  updatePeriodEndsAt\n  objectionPeriodEndsAt\n  voteEndsAt\n  voteStartsAt\n  transactions {\n    signature\n    calldata\n    ...ProposalTransactionDisplayFragment\n  }\n  proposer {\n    address {\n      resolvedName {\n        ...NounResolvedLinkFragment\n        address\n      }\n    }\n    id\n  }\n  signers {\n    address {\n      resolvedName {\n        ...NounResolvedLinkFragment\n        address\n      }\n    }\n    id\n  }\n  updateHistory {\n    timestamp\n    id\n  }\n  ...UpdateHistoryDialogContentFragment\n}\n\nfragment ProposalFeedbackSummaryFragment on OnChainProposal {\n  feedbackAggregates {\n    positiveFeedback {\n      amount\n    }\n    negativeFeedback {\n      amount\n    }\n    ...ProposalFeedbackSummaryVotesBarFragment\n  }\n  ...ProposalFeedbackSummaryVoteTimeFragment\n}\n\nfragment ProposalFeedbackSummaryVoteTimeFragment on OnChainProposal {\n  voteStartsAt\n  voteEndsAt\n}\n\nfragment ProposalFeedbackSummaryVotesBarFragment on FeedbackAggregates {\n  positiveFeedback {\n    amount\n  }\n  negativeFeedback {\n    amount\n  }\n  neutralFeedback {\n    amount\n  }\n}\n\nfragment ProposalTransactionDisplayFragment on ProposalTransaction {\n  target {\n    resolvedName {\n      address\n      name\n    }\n  }\n  calldata\n  signature\n  value\n}\n\nfragment ProposalVotesSummaryFragment on OnChainProposal {\n  forVotes {\n    amount\n  }\n  againstVotes {\n    amount\n  }\n  quorumVotes {\n    amount\n  }\n  ...ProposalVotesSummaryVotesBarFragment\n  ...ProposalVotesSummaryVoteTimeFragment\n}\n\nfragment ProposalVotesSummaryVoteTimeFragment on OnChainProposal {\n  voteStartsAt\n  voteEndsAt\n}\n\nfragment ProposalVotesSummaryVotesBarFragment on OnChainProposal {\n  forVotes {\n    amount\n  }\n  againstVotes {\n    amount\n  }\n  abstainVotes {\n    amount\n  }\n}\n\nfragment UpdateHistoryDialogContentFragment on UpdatableProposal {\n  __isUpdatableProposal: __typename\n  updateHistory {\n    timestamp\n    transactionHash\n    id\n  }\n}\n\nfragment VoteReasonFragment on Vote {\n  reason\n}\n\nfragment VoteRowFragment on Vote {\n  id\n  reason\n  votes {\n    amount {\n      amount\n    }\n  }\n  voter {\n    address {\n      address\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    id\n  }\n  executor {\n    address {\n      address\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    id\n  }\n  ...VoteRowTextFragment\n  ...VoteReasonFragment\n}\n\nfragment VoteRowTextFragment on Vote {\n  supportDetailed\n}\n\nfragment VotesCastPanelFragment on OnChainProposal {\n  number\n  ...ProposalVotesSummaryFragment\n  ...CastVoteInputFragment\n  ...CastVoteInputVoteButtonsFragment\n}\n\nfragment VotesCastPanelOwnVotesFragment_248kg0 on Query {\n  delegate(addressOrEnsName: $address) @skip(if: $skipAddress) {\n    votes {\n      proposal {\n        id\n      }\n      ...VoteRowFragment\n      id\n    }\n    id\n  }\n}\n\nfragment VotesCastPanelQueryFragment_zQ1q7 on Query {\n  ...VotesCastPanelVotesFragment_2weWiM\n  ...CastVoteInputQueryFragment_248kg0\n  ...CastVoteInputVoteButtonsQueryFragment_248kg0\n  ...VotesCastPanelOwnVotesFragment_248kg0\n}\n\nfragment VotesCastPanelVotesFragment_2weWiM on Query {\n  votes(proposalId: $proposalId, orderBy: $orderBy, first: 30) {\n    edges {\n      node {\n        executor {\n          address {\n            address\n          }\n          id\n        }\n        ...VoteRowFragment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36965897ff92819c1915c26f6a91c66b";

export default node;
